import { render } from "./ManageSoAModal.vue?vue&type=template&id=eade37a8&scoped=true"
import script from "./ManageSoAModal.vue?vue&type=script&lang=js"
export * from "./ManageSoAModal.vue?vue&type=script&lang=js"

import "./ManageSoAModal.vue?vue&type=style&index=0&id=eade37a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eade37a8"]])

export default __exports__